import React, { useState, useRef, useEffect } from "react";
import "../../styles/pages/product-page.css";
import { ProductCategoryDto } from "../../api/productCategories";

interface Props {
  search: string;
  onSearchChange: (v: string) => void;
  filterType: "all" | "product" | "service";
  onFilterTypeChange: (v: "all" | "product" | "service") => void;
  filterStock: "all" | "in" | "out";
  onFilterStockChange: (v: "all" | "in" | "out") => void;
  filterCategory: number | "all";
  onFilterCategoryChange: (v: number | "all") => void;
  categories: ProductCategoryDto[];
  sortStock: "none" | "asc" | "desc";
  onSortStockChange: (v: "none" | "asc" | "desc") => void;
  onResetFilters: () => void;
}

export default function ProductTopBar({
  search, onSearchChange,
  filterType, onFilterTypeChange,
  filterStock, onFilterStockChange,
  categories, onResetFilters,
}: Props) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const hasFilters = filterType !== "all" || filterStock !== "all";
  const wrapRef = useRef<HTMLDivElement>(null);

  // Закрываем при клике вне
  useEffect(() => {
    if (!filtersOpen) return;
    function handleClick(e: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setFiltersOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [filtersOpen]);

  return (
    <div className="product-topbar" ref={wrapRef}>
      {/* Строка поиска + кнопка фильтров */}
      <div className="product-search-wrapper" style={{ flex: 1 }}>
        <input
          className="product-search"
          placeholder="Название, SKU или штрихкод"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {search.length > 0 && (
          <button className="product-search-clear" onClick={() => onSearchChange("")}>✕</button>
        )}
      </div>

      <button
        className={"stock-filter-toggle" + (hasFilters ? " active" : "")}
        onClick={() => setFiltersOpen(o => !o)}
      >
        Фильтры {hasFilters ? "●" : (filtersOpen ? "▲" : "▼")}
      </button>

      {/* Дропдаун фильтров — абсолютный, выезжает вниз */}
      {filtersOpen && (
        <div className="product-filters-dropdown">
          <div className="product-filters-row">
            <label className="filter-label">Тип</label>
            <select
              className="product-filter"
              value={filterType}
              onChange={(e) => onFilterTypeChange(e.target.value as any)}
            >
              <option value="all">Все типы</option>
              <option value="product">Товары</option>
              <option value="service">Услуги</option>
              <option value="software">ПО</option>
            </select>
          </div>

          <div className="product-filters-row">
            <label className="filter-label">Наличие</label>
            <select
              className="product-filter"
              value={filterStock}
              onChange={(e) => onFilterStockChange(e.target.value as any)}
            >
              <option value="all">Все</option>
              <option value="in">В наличии</option>
              <option value="out">Нет в наличии</option>
            </select>
          </div>

          <button
            className="product-reset-btn"
            style={{ width: "100%", marginTop: 4 }}
            onClick={() => { onResetFilters(); setFiltersOpen(false); }}
          >
            Сбросить фильтры
          </button>
        </div>
      )}
    </div>
  );
}
